import {
    Component,
    Input,
    SimpleChanges,
    OnChanges,
    inject,
} from '@angular/core';
import {
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { FilterPanelComponent } from '../../../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../../../common/grid-page.component';
import {
    CreditRequestStatus,
    CreditRequestHistoryGridViewDto,
} from '@services';
import EnumUtils from '../../../../../shared/enum-utils';
import { CommonModule } from '@angular/common';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';
import { CustomStore } from 'devextreme-aspnet-data-nojquery';
import { CreditRequestStatusPipe } from 'src/app/pipes/credit-requests-status.pipe';

@Component({
    selector: 'app-credit-request-history',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSearchPanelComponent,
        DxoSelectionComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxiColumnComponent,
        DxTemplateDirective,
        FilterPanelComponent,
        DxFormComponent,
        UserAvatarEmailComponent,
        CreditRequestStatusPipe,
    ],
    providers: [CreditRequestStatusPipe],
    templateUrl: './credit-request-history.component.html',
})
export class CreditRequestHistoryComponent
    extends GridPageComponent<CreditRequestHistoryGridViewDto>
    implements OnChanges
{
    @Input() number: string | null = null;
    protected override exportName: string = 'Credit Request History';
    protected offset: number = 160;

    private creditRequestStatusPipe = inject(CreditRequestStatusPipe);

    dateTimeFormat = DATE_TIME_FORMAT;
    dataSource :  CustomStore | CreditRequestHistoryGridViewDto[] = [];

    statusOptions = EnumUtils.getEnumOptions(CreditRequestStatus, (v) =>
        this.creditRequestStatusPipe.transform(v),
    );

    createdByFilter = this.userNameOrEmailFilter('createdBy');

    protected override filterConfig: FilterConfig[] = [
        {
            field: 'createdBy.name',
            op: 'contains',
            customFilter: this.createdByFilter,
        },
        { field: 'created', op: '>=' },
        { field: 'status', op: '=' },
    ];

    constructor() {
        super();
        this.init(CreditRequestHistoryGridViewDto);
    }

    protected getBadgeClass(status: CreditRequestStatus | undefined): string {
        return EnumUtils.getCreditRequestStatusBadgeClass(status);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['number']) {
            this.dataSource = this.dataSources.creditRequestHistory(
                this.number,
            );
        }
    }
}
